export default "__VITE_ASSET__96cf7d03__"